import Women from '../../assets/woman-working-laptop.png';
import Union from '../../assets/Union.svg';

const MobileLanding = ({ navigate }) => {
  return (
    <div className="relative min-h-screen bg-primary-50 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 w-full content-end">
        <img src={Union} alt="" className="w-full h-auto mt-32" />
      </div>

      {/* Main Content Container */}
      <div className="relative z-10 flex flex-col min-h-screen">
        {/* Teachers Text */}
        <div className="w-full text-center mt-24">
          <h1 className="text-[60px] sm:text-[72px] font-black uppercase tracking-tight hero-text-gradient transform -translate-x-2">
            TEACHERS
          </h1>
        </div>

        {/* Text Content */}
        <div className="text-center mt-8">
          <h2 className="text-[18px] sm:text-[20px] text-primary-text leading-tight font-medium mb-4 px-4">
            CONNECTING EXCEPTIONAL TEACHERS
            <br />
            WITH LEADING INSTITUTIONS
          </h2>
          <p className="text-base text-primary-text mb-6 px-4 max-w-md mx-auto">
            Your One-Stop Platform for Finding Your Next Role in Education or Your Next Great Hire
          </p>
          <button
            onClick={() => navigate('/login')}
            className="w-[90%] max-w-xs mx-auto bg-primary-500 text-primary-50 px-6 py-3 rounded-full text-base hover:bg-opacity-90 transition-colors duration-200 block"
          >
            Find your dream job
          </button>
        </div>

        {/* Image Container */}
        <div className="mt-8 flex-grow flex items-end">
          <img src={Women} alt="Teacher working on laptop" className="w-full h-auto object-contain max-h-[50vh]" />
        </div>
      </div>
    </div>
  );
};

export default MobileLanding;
